<template>
  <div v-loading.fullscreen.lock="loading" class="main_center clearfix">


    <el-form ref="form" :model="form" :rules='rules' label-width="150px" class="form">
      <div class="top-content">
        <div class="left-navbar">
          <el-button size="small" @click="backBtn">返回</el-button>
          <!--                    <right-nav :childData='listNav'></right-nav>  -->
          <el-button type="primary" size="small" plain style="margin-right:10px;" @click="save()">保存</el-button>

        </div>
      </div>
      <div class="right-content">
        <el-card class="box-card" :style="{ 'height': cardHight }">
          <div slot="header" class="clearfix">
            <span>第三方对接系统配置信息</span>
          </div>

          <el-row>
            <el-col :span="12">
              <el-form-item label="系统名称：" prop='systemName' style="width:100%;">
                <el-input v-model="form.systemName" maxlength="100" show-word-limit></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属单位：" prop='orgName' style="width:100%;">
                <el-input v-model="form.orgName" maxlength="50" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
<!--          <el-row>
            <el-col :span="12">
              <el-form-item label="访问token：" prop='token' style="width:100%;">
                <el-input v-model="form.token" maxlength="50" show-word-limit disabled style="width: 90%;"></el-input>
                <el-button class="el-icon-refresh" @click="createToken" type="text"></el-button>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="访问地址：" prop='accessUrl' style="width:100%;">
                <el-input v-model="form.accessUrl" maxlength="100" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>-->
<!--          <el-row>
            <el-col :span="12">
              <el-form-item label="回调接口：" prop='callback' style="width:100%;">
                <el-input v-model="form.callback" maxlength="100" show-word-limit></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="接口密钥：" prop='secrets' style="width:100%;">
                <el-input v-model="form.secrets" maxlength="50" show-word-limit disabled style="width: 90%;"></el-input>
                <el-button class="el-icon-refresh" @click="createSecret" type="text"></el-button>
              </el-form-item>
            </el-col>
          </el-row>-->
          <el-row>
            <el-col :span="12">
              <el-form-item label="接口类型：" prop='interType'>
                <el-select v-model="form.interType" style="width:100%;" @change="selectInterTypeClick($event)">
                  <el-option v-for="(item, index) in interTypeNameList" :key="item.value" :label="item.name"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="文件获取方式：" prop='fileDownMod'>
                <el-select v-model="form.fileDownMod" style="width:100%;" @change="selectFileDownModClick($event)">
                  <el-option v-for="(item, index) in fileDownModNamelist" :key="item.value" :label="item.name"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="所属监管单位：" prop='tradeId' style="width:100%;">
                <el-select filterable style="width:100%;" v-model="form.tradeId">
                  <el-option v-for="(item, index) in tradeIdList" :key="item.id" :label="item.orgName" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="关联应用：" prop='appId' style="width:100%;">
                <el-select filterable style="width:100%;" v-model="form.appId">
                  <el-option :key="item.id" :label="item.appName" :value="item.id" v-for="(item, index) in appList">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
      </div>

    </el-form>
  </div>
</template>

<script>

import { strLength_5, strLength_7 } from '@/utils/validate';
// import {tabsCloseCurrentHandle} from '@/utils/routeTab';

export default {
  components: {},
  data() {
    return {
      interTypeNameList: [],
      fileDownModNamelist: [],
      tradeIdList: [],
      appList: [],
      cardHight: (document.documentElement.clientHeight - 116) + 'px',
      loading: false,
      form: {
        id: "",
        systemName: '',//系统名称
        orgName: '',//所属单位
        token: '',//访问token
        accessUrl: '',//访问地址
        callback: '',//回调接口
        secrets: '',//接口密钥
        interType: '',//接口类型
        fileDownMod: '',//文件获取方式
        tradeId: '',
        appId:''
      },
      rules: {
        systemName: [{ required: true, message: '请输入系统名称', trigger: 'blur' }, { validator: strLength_7, trigger: 'blur' }],
        orgName: [{ required: true, message: '请输入所属单位', trigger: 'blur' }, { validator: strLength_5, trigger: 'blur' }],
        token: [{ required: true, message: '请输入访问token', trigger: 'blur' }, { validator: strLength_5, trigger: 'blur' }],
        accessUrl: [{ required: true, message: '请输入访问地址', trigger: 'blur' }, { validator: strLength_7, trigger: 'blur' }],
        callback: [{ required: true, message: '请输入回调接口', trigger: 'blur' }, { validator: strLength_7, trigger: 'blur' }],
        secrets: [{ required: true, message: '请输入接口密钥', trigger: 'blur' }, { validator: strLength_5, trigger: 'blur' }],
        interType: [{ required: true, message: '请输入接口类型', trigger: 'blur' }],
        fileDownMod: [{ required: true, message: '请输入文件获取方式', trigger: 'blur' }],
        tradeId: [{ required: true, message: '请输入所属交易中心', trigger: 'blur' }],
        appId: [{ required: true, message: '请输入关联应用', trigger: 'blur' }]
      },
      upAddIndex: '', //判断是新增还是详情页
      saveClick: false,
      errorData: {},
    }
  },
  activated() {



    this.form.id = window.sessionStorage.getItem("id");
    this.getDataById();

    this.upAddIndex = window.sessionStorage.getItem("addUpdateIndex");

  },
  computed: {},
  mounted() {
    this.getDic('jz_interface_type')
    this.getDic('jz_third_filedownmod')
    this.getAppList();
    this.selectTradeId();
  },
  methods: {
    selectTradeId() {
      //tradeIdList 原接口sysGuardConfig/traddingOrgPage
      this.$httpReq.post('/sysGuardConfig/supervisionOrgPage', {
        "filter": {
          "actionType": 1
        },
        "page": 1,
        "rows": 100,
        "searchKey": "",
      }).then(res => {
        this.tradeIdList = res.data.rows
      })
    },
    getDic(type) { // 获取字典
      this.$httpReq.get('/sys/dictData/getList?type=' + type).then(res => {
        if (res.data.code === '1') {
          switch (type) {
            case 'jz_interface_type': this.interTypeNameList = res.data.data; break;
            case 'jz_third_filedownmod': this.fileDownModNamelist = res.data.data; break;
          }
        }
      })
    },
    backBtn() { //返回
      tabsCloseCurrentHandle();
      this.clearData()
      this.$router.push({
        name: 'thirds_config_list'
      })

    },
    clearData() {
      this.$refs.form.resetFields();
    },
    getDataById() { //详情

      if (this.form.id != "") {

        this.$httpReq.get('/thirdsConfig/get?id=' + this.form.id).then(res => {
          if (res.data.code == '1') {
            this.form.id = res.data.data.id
            const data = res.data.data
            this.form = {
              id: this.form.id,
              systemName: data.systemName,//系统名称
              orgName: data.orgName,//所属单位
              token: data.token,//访问token
              accessUrl: data.accessUrl,//访问地址
              callback: data.callback,//回调接口
              secrets: data.secrets,//接口密钥
              interType: data.interType,//接口类型
              fileDownMod: data.fileDownMod.toString(),//文件获取方式
              tradeId: data.tradeId,
              appId: data.appId
            }
          }
        })

      } else {
        //  新增
        this.$refs['form'].resetFields();

      }
    },
    save() { //新增&保存
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$httpReq.post('/thirdsConfig/save', this.form).then(res => {
            if (res.data.code == '1') {

              this.form.id = res.data.data.id
              window.sessionStorage.setItem("id", res.data.data.id);

              this.$message({
                type: 'success',
                message: res.data.msg
              })
              this.$router.push({
                name: 'thirds_config_view'
              })
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
              this.errorData = res.data.data || {};
            }
          })

        }
      })
    },

    selectInterTypeClick(val) {
      this.interTypeNameList.forEach((item, index) => {
        if (item.value == val) {
          this.form.interTypeName = item.name
        }
      });
    },
    selectFileDownModClick(val) {
      this.fileDownModNamelist.forEach((item, index) => {
        if (item.value == val) {
          this.form.fileDownModName = item.name
        }
      });
    },

    createRandom(salt) {
      let token = this.$md5(this.form.systemName + (salt + Math.random()) * 0x100000)
      return token;
    },

    createToken() {
      this.form.token = this.createRandom(0);
    },
    createSecret() {
      this.form.secrets = this.createRandom(100);
    },
    getAppList(){
      this.$httpReq.post('/thirdsConfig/appList', {
        page: 1,
        rows: 999,
        searchKey: "",
        filter: {}
      }).then(res => {
        this.appList=res.data.rows||[];
      })
    }

  }
}
</script>

<style lang="scss" scoped>
.main_center {
  height: 100%;

  .right-content {
    .set_btn {
      float: right;
      margin-bottom: 20px;
    }

    .more_btn {
      text-align: center;
    }

    .upload-demo {
      display: flex;
      height: 34px;
      border-bottom: 1px solid #dcdfe6;

      .el-button {
        position: absolute;
        right: 0;
      }
    }
  }
}

.el-dialog__body {
  padding-top: 0;

  .dia_top {
    text-align: center;
    margin-top: -3%;
  }

  .dialog_title {
    text-align: right;
    box-sizing: border-box;
    border: 1px solid #ebeef5;
    padding: 10px 10px 10px 0;
    border-bottom: none;

    .search_btn {
      margin-left: 20px;
    }
  }
}

.backBtn {
  margin-right: 10%;
}
</style>
